// @flow
/* eslint-disable no-useless-escape */

import { translate } from '../../../react/features/base/i18n/functions';
import { updateSettings } from '../../../react/features/base/settings/actions';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { isPrejoinEnabledInConfig } from '../../../react/features/prejoin/functions.any';
import { IconFb, IconGoogleAuth, IconLinked, IconTw, IconWizyconf } from '../../components/base/icons/svg';
import { hideWildixModal } from '../../components/base/modal/actions';


import PopupOverlay from './PopupOverlay';


type Props = {

    /**
     * Invoked to obtain translated strings.
     */
    t: Function,
    hideWildixModal: Function,
    roomToken: ?string
};

type State = {
    formFields: Object
};

const SOCIAL_LINKS = [
    {
        name: 'facebook',
        icon: IconFb
    },
    {
        name: 'google',
        icon: IconGoogleAuth
    },
    {
        name: 'twitter',
        icon: IconTw
    },
    {
        name: 'linkedin',
        icon: IconLinked
    }
];

// eslint-disable-next-line max-len
const EMAIL_REGEX = RegExp(/^(|(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\-+)|([A-Za-z0-9]+\.+)|([A-Za-z0-9]+\++))*[A-Za-z0-9]+@((\w+\-+)|(\w+\.))*\w{1,63}\.[a-zA-Z]{2,63})$/i);

class PopupAuth extends PureComponent<Props> {

    state: State = {
        socialAuthError: false,
        formFields: {
            fullName: {
                required: true,
                value: '',
                isValid: false,
                errorTitle: '',
                maxLength: 256,
                errors: {
                    longText: 'Name and surname is very long',
                    empty: 'Name and surname cannot be empty'
                }
            },
            email: {
                required: false,
                value: '',
                isValid: false,
                errorTitle: '',
                maxLength: 256,
                emailRegex: EMAIL_REGEX,
                errors: {
                    longText: 'Email is very long',
                    noValid: 'Email is not valid!'
                }
            }
        }
    };

    constructor(props: Props) {
        super(props);

        // eslint-disable-next-line camelcase
        window.conference_authenticated = data => {
            this.setState({
                socialAuthError: false
            });
            if (data?.auth_provider && data?.profile_id) {
                APP.store.dispatch(updateSettings({
                    displayName: data.name,
                    email: data.mail,
                    avatarURL: data.photo_url,
                    role: APP.wildix.methods.conferenceRole()
                }));
                this.initConference();
            } else {
                this.setState({
                    socialAuthError: true
                });
            }
        };
    }

    componentDidMount() {
        APP.wildix.storage.setTitle('');
    }

    initConference = () => {
        APP.conference.init({
            roomName: this.props.roomToken,
            shouldDispatchConnect: !isPrejoinEnabledInConfig(APP.store.getState())
        });
        this.props.hideWildixModal();
    };

    onSocialSignIn = provider => {
        window.open(
            `${location.protocol}//${location.host}/auth/authenticate?provider=${provider}`,
            'hybridauth_social_sing_on',
            'location=0,status=0,scrollbars=0,width=800,height=500'
        );
    };

    handleChange = event => {
        event.preventDefault();
        const { name, value } = event.target;

        this.validateForm(name, value);
    };

    validateForm = (name, value) => {
        const formFields = this.state.formFields;
        const formFieldName = formFields[name];
        const objectErrors = formFieldName.errors;

        switch (name) {
        case 'fullName':
            formFieldName.errorTitle = value.length === 0
                ? objectErrors.empty : value.length > formFieldName.maxLength
                    ? objectErrors.longText : '';

            formFieldName.isValid = Boolean(formFieldName.errorTitle);
            formFieldName.value = value;
            break;
        case 'email':
            formFieldName.errorTitle = value.length === 0 ? ''
                : value.length > formFieldName.maxLength ? objectErrors.longText
                    : formFieldName.emailRegex.test(value) ? '' : objectErrors.noValid;

            formFieldName.isValid = Boolean(formFieldName.errorTitle);
            formFieldName.value = value;
            break;
        default:
            break;
        }

        this.setState({
            formFieldName,
            [name]: value
        });
    };

    validateTitle = formFields => {
        let valid = true;

        Object.values(formFields).forEach(

            // if we have an error string set valid to false
            val => val.errorTitle.length > 0 && (valid = false)
        );

        return valid;
    };

    validateFields = form => {
        const data = new FormData(form);
        const formFields = this.state.formFields;

        for (const name of data.keys()) {
            const input = form.elements[name];

            if (formFields[input.name].required) {
                // eslint-disable-next-line no-shadow
                const { name, value } = input;

                this.validateForm(name, value);
            }
        }

        return this.validateTitle(formFields);
    };

    handleSubmit = event => {
        event.preventDefault();
        if (this.validateFields(event.target)) {
            const { fullName, email } = this.state.formFields;

            APP.store.dispatch(updateSettings({
                displayName: fullName.value,
                email: email.value
            }));
            this.initConference();
        } else {
            console.error('Invalid Form');
        }
    };

    renderSocialLinks = () => SOCIAL_LINKS.map((item, index) => (
        <div className={'social-icon social_margin'}
            key={index}
            onClick={() => this.onSocialSignIn(item.name)}>
            {React.createElement(item.icon)}
        </div>
    ));

    render() {
        const { t } = this.props;
        const { fullName, email } = this.state.formFields;

        return (
            <PopupOverlay className={'popup__auth popup__light'}>
                <div className="logo__wizy__small">
                    <IconWizyconf/>
                </div>

                <div className={'user__auth'}>
                    <h4 className={'popup__title'}>
                        {t('auth.pleaseSignInWith')}
                    </h4>

                    <form onSubmit={this.handleSubmit}>
                        <div className="popup-auth__item">
                            <input onChange={this.handleChange}
                                className={fullName.isValid ? 'input__error' : null}
                                name="fullName"
                                type="text"
                                autoComplete={'off'}
                                placeholder={t('auth.name')}/>
                            {fullName.isValid
                            && <span className='input__error-text'>{fullName.errorTitle}</span>}
                        </div>
                        <div className="popup-auth__item">
                            <input onChange={this.handleChange}
                                className={email.isValid ? 'input__error' : null}
                                name="email"
                                type="text" placeholder={t('auth.email')}/>
                            {email.isValid && <span className='input__error-text'>{email.errorTitle}</span>}
                        </div>
                        <button className={'btn btn_full btn_yellow'} type={'submit'}>
                            {t('button.join')}
                        </button>
                    </form>

                    <h4 className={'popup__title'}>
                        {t('auth.signSocial')}
                    </h4>
                    <div className="flex_hor-center">
                        {this.renderSocialLinks()}
                    </div>
                    {this.state.socialAuthError
                        && <p className='error-text'>Social auth not successful. Try again later.</p>
                    }
                    <div className="policy">
                        <a href="https://www.wildix.com/wildix-privacy-cookie-policy" target="_blank" rel="noreferrer">
                            {t('auth.privacyPolicy')}
                        </a>
                    </div>
                </div>
            </PopupOverlay>
        );
    }
}

function _mapStateToProps(state) {
    return {
        roomToken: state['features/base/config'].roomToken
    };
}

function _mapDispatchToProps(dispatch) {
    return {
        hideWildixModal: () => dispatch(hideWildixModal())
    };
}

export default translate(connect(_mapStateToProps, _mapDispatchToProps)(PopupAuth));
